<div *ngIf="!selected">
  <div class="feature-panel" (click)="fitFeature()" (mouseenter)="hover = true" (mouseleave)="hover = false">

    <div class="feature-panel-center">
      <span class="primary-field text-truncate" [class.highlight]="this.primaryFieldHighlight">
        {{feature?.properties[primaryField]?.toString() || 'No value'}}
      </span>
      <span class="secondary-field text-secondary text-truncate" [class.highlight]="this.secondaryFieldHighlight">
        {{feature?.properties[secondaryField]}}
      </span>
    </div>
    <div class="feature-panel-actions">
      <mat-icon *ngIf="hover">send</mat-icon>
      <mat-icon *ngIf="focus">remove_red_eye</mat-icon>
    </div>
  </div>
  <mat-divider></mat-divider>
</div>
